
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class StatusPill extends Vue {
  @Prop({ required: true }) label!: string;

  @Prop({ default: 'grey' }) color!: 'grey' | 'danger' | 'warning' | 'success' | 'orange' | 'blue' | 'primary';
}
